import { InjectionToken, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/overlay';
import { Observable } from 'rxjs';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { DialogV2 } from '@ui/dialog-v2/dialog-v2';


export type DialogIcon = {
    variant: BsIconTypes,
    label?: string,
    style?: 'white' | 'gray' | 'black' | 'success' | 'danger',
}

export interface DialogParams {
    templateId?: string;
    dialogRef: MatDialogRef<DialogV2>;
    confirmFunction?: any;
    cancelFunction?: any;
    serviceParams?: any;
    pending$?: Observable<boolean> | undefined;
    noteRequired?: boolean | undefined;
    resetFieldAfterSubmit?: boolean | undefined;
    title?: string;
    description?: string;
    icon?: DialogIcon;
    dialogContentPaddingClass?: string;
}

export interface DialogData {
    component: ComponentType<any>;
    injector: Injector;
    params: DialogParams;
}

export const DIALOG_DATA = new InjectionToken<DialogParams>('Dialog Data');

export enum DialogWidth {
    SM = '450px',
    MD = '650px',
    LG = '800px',
    XL = '960px',
    XXL = '1200px',
}
